
import { Component, Vue, Watch } from 'vue-property-decorator'
import { StationClient } from '@/api'
import StationEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
var QRCode = require('qrcode')

@Component({
  name: 'StationList',
  components: {
    StationEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new StationClient()
    this.listQuery = {
      filter: {
        where: { name: { like: '' } },
        fields: {
          // id: true,
          // name: true,
          // cover: true,
          // address: true,
          // latitude: true,
          // longitude: true,
          // createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {}
  async mounted() {
    await super.getList()
  }

  protected generateQuery(): any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    return t
  }
  drawQRCode() {
    for (let index in this.list) {
      let item: any = this.list[index]
      let lngCanvas = document.getElementById('lng_qr_canvas_' + index)
      if (!lngCanvas) {
        return
      }
      let cngCanvas = document.getElementById('cng_qr_canvas_' + index)
      if (!cngCanvas) {
        return
      }
      let lngParam = encodeURIComponent(
        JSON.stringify({
          stationId: item.id,
          gasType: 'LNG'
        })
      )
      let lngData = `https://www.xjjnxd.com/jnxunda/payment_static/${lngParam}`
      QRCode.toCanvas(lngCanvas, lngData, function(error: any) {
        if (error) console.error(error)
      })

      let cngParam = encodeURIComponent(
        JSON.stringify({
          stationId: item.id,
          gasType: 'CNG'
        })
      )
      let cngData = `https://www.xjjnxd.com/jnxunda/payment_static/${cngParam}`
      QRCode.toCanvas(cngCanvas, cngData, function(error: any) {
        if (error) console.error(error)
      })
    }
  }

  @Watch('list')
  private onListDataChange() {
    let self = this
    this.$nextTick(() => {
      self.drawQRCode()
    })
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: any) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
  private onLngQRTap(index:any) {
    let a = document.createElement('a')
    let canvas: any = document.getElementById('lng_qr_canvas_' + index)
    if (!canvas) {
      return
    }
    let item:any = this.list[index]
    a.href = canvas.toDataURL('image/png') // 将画布内的信息导出为png图片数据
    a.download = `${item.name}LNG收款二维码` // 设定下载名称
    a.click() // 点击触发下载
  }
  private onCngQRTap(index:any) {
    let a = document.createElement('a')
    let canvas: any = document.getElementById('cng_qr_canvas_' + index)
    if (!canvas) {
      return
    }
    let item:any = this.list[index]
    a.href = canvas.toDataURL('image/png') // 将画布内的信息导出为png图片数据
    a.download = `${item.name}CNG收款二维码` // 设定下载名称
    a.click() // 点击触发下载
  }
}
